// @flow
import ko from 'rgs-knockout';
import type { Observable } from 'rgs-knockout';
import _ from 'lodash';

import type { PureComputed } from 'rgs-knockout';

import { withProps } from '../helpers';

export type TButton = {
	content: Observable<string> | PureComputed<string> | string,
	onClick?: (*) => any,
	isWide?: boolean,
	iconClass?: string,
	btnClasses?: any,
	enable?: Observable<boolean> | PureComputed<boolean> | boolean,
}
type Props = $NonMaybeType<TButton>;

export default class Button {
	props: Props;

	constructor (options: TButton) {
		const {
			onClick = _.noop,
			btnClasses = {},
			enable = true,
			isWide = false,
			content = '',
			iconClass,
			...rest
		} = withProps(options);

		this.props = {
			content: ko.pureComputed(() => ko.unwrap(content)),
			btnClasses: { 'nfd-btn-wide': isWide, ...btnClasses },
			onClick,
			iconClass,
			enable,
			...rest,
		};
	}
}
